import fslightbox from 'fslightbox';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import barba from '@barba/core';
import { initializeSwiper } from './swiper.js';
import { initializeScrollAnimations } from './gsap-animation.js';
import { contactForm, closePopupEsc, footerLogoAnimation, menuThumbnailHover, scrollToSectionFromHero, fireMobileMenu, setFullHeight, sectionStickyMore } from './scripts.js';
import { ajaxCalls } from './ajax.js';
import { lenis } from './scripts.js';

function afterEnterScript() {
    contactForm();
    closePopupEsc();
    menuThumbnailHover();
    scrollToSectionFromHero();
    refreshFsLightbox();
    ajaxCalls();
    footerLogoAnimation();
    initializeScrollAnimations();
    sectionStickyMore();
}

export function initBarba() {

    document.addEventListener('click', function (event) {
        if (event.target.closest('#scroll-to-top')) {
            lenis.scrollTo(0, { duration: 1.2 });
        }
    });

    const loader = document.querySelector('.loader');

    gsap.set(loader, { autoAlpha: 0 }); // ← tylko to na starcie

    function loaderIn() {
        return gsap.to(loader, {
            duration: 0.5,
            autoAlpha: 1,
            ease: 'Power4.out',
        });
    }

    function loaderAway() {
        return gsap.to(loader, {
            duration: 0.5,
            autoAlpha: 0,
            ease: 'Power4.in',
        });
    }

    barba.hooks.before((data) => {
        document.querySelector('html').classList.add('is-transitioning');
        barba.wrapper.classList.add('is-animating');

        const href = data.trigger?.getAttribute?.('href');
        if (href?.includes('#')) {
            sessionStorage.setItem('scrollTo', '#' + href.split('#')[1]);
        }

        console.log('before event');
    });

    barba.hooks.after(async () => {
        await loaderAway();
        document.querySelector('html').classList.remove('is-transitioning');
        barba.wrapper.classList.remove('is-animating');
        initializeSwiper();
        fireMobileMenu();
        setFullHeight();

        window.dataLayer = window.dataLayer || [];
        function gtag() {
            dataLayer.push(arguments);
        }

        gtag('event', 'page_view', {
            'page_title': document.title,
            'page_location': location.href,
            'page_path': location.pathname,
        });

        console.log('after event');

        const hash = sessionStorage.getItem('scrollTo');

        if (hash) {
            sessionStorage.removeItem('scrollTo');
            setTimeout(() => {
                const target = document.querySelector(hash);
                if (target) {
                    lenis.scrollTo(target, {
                        offset: 0,
                        duration: 1.2
                    });
                }
            }, 300);
        }
    });

    barba.hooks.afterEnter(() => {
        afterEnterScript();
        document.dispatchEvent(new CustomEvent('barba:afterEnter'));
    });

    barba.hooks.afterLeave(() => {
        ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    });

    barba.init({
        timeout: 7500,
        transitions: [{
            async leave() {
                //lenis.scrollTo(0, { immediate: true });
                await loaderIn();
            },
            beforeEnter: ({ next }) => {
                lenis.scrollTo(0, { immediate: true });

                if (!next.html.includes('<body')) {
                    return;
                }

                const matches = next.html.match(/<body.+?class="([^""]*)"/i);
                document.body.setAttribute('class', (matches && matches.at(1)) ?? '');

                const cf_selector = 'div.wpcf7 > form';
                const cf_forms = next.container.querySelectorAll(cf_selector);

                if (cf_forms.length > 0) {
                    cf_forms.forEach(function (form) {
                        wpcf7.init(form);
                    });
                }
            },
        }]
    });
}